import { Box, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { FrequencyEnum } from "../../../form/components/steps/configCalendar/enums"
import { DayOfWeeksSelector } from "../../../form/components/steps/dayOfWeeksSelector"
import { Constants } from "../../../../../../utils/constants"
import { DateModalRange } from "../../../../../../components/dinamicForm/dateModal"
import { PropsSerie } from "./types"
import { useStyles } from "./styles"
import { useEffect, useState } from "react"




const SerieInput = ({ type, selectedsDays, data, errors, onChange, startDate, mimTimeZone, maxToDay, refRange }: PropsSerie) => {
    const { t } = useTranslation()
    const styles = useStyles();
    const [contador, setContador] = useState(0)

    const contarDiasHabiles = (from: any, to: any): number => {
        let contador = 0;
        let fecha = new Date(from);
        const newSelectedsDays = selectedsDays.map(day => day == 7 ? 0 : day)

        while (fecha <= to) {
            const diaSemana = fecha.getDay(); // 0 = Domingo, 1 = Lunes, ..., 6 = Sábado
            if (newSelectedsDays.includes(diaSemana)) {
                contador++;
            }
            fecha.setDate(fecha.getDate() + 1);
        }

        return contador;
    }

    useEffect(() => {
        if (data.to && data.from) {
            setContador(contarDiasHabiles(data.from, data.to))
        }
    }, [data.from, data.to, selectedsDays])


    return (
        <Box>
            <Box sx={styles.container}>
                {type !== FrequencyEnum.DAYLI && <Typography variant="text_grey">{t('schedule.assigned.businessDay')}</Typography>}
                {type !== FrequencyEnum.DAYLI && <DayOfWeeksSelector startDate={startDate} selectedDay={selectedsDays} multiple={true} />}
                <DateModalRange
                    mimTimeZone={mimTimeZone ?? Constants.defaultTimeZoneObject}
                    defaultErrors={{ from: errors?.from, to: errors?.to }}
                    setDate={(payload) => {
                        onChange({
                            target: {
                                name: payload.target.name,
                                value: payload.target.value,
                            }
                        })
                    }}
                    from={data.from}
                    to={data.to ?? null}
                    ref={refRange}
                    maxToDay={maxToDay}
                />
                {type !== FrequencyEnum.DAYLI && <Typography sx={styles.text}>{t('schedule.assigned.theExecutionIsAvailableFrom')}<span>{t('schedule.assigned.executionAvailabe', { count: contador, amount: contador })}</span></Typography>}
            </Box>

        </Box>
    )
}

export { SerieInput }
